import { render, staticRenderFns } from "./Step2.vue?vue&type=template&id=524bd414&"
import script from "./Step2.vue?vue&type=script&lang=js&"
export * from "./Step2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\270b-ariq\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('524bd414')) {
      api.createRecord('524bd414', component.options)
    } else {
      api.reload('524bd414', component.options)
    }
    module.hot.accept("./Step2.vue?vue&type=template&id=524bd414&", function () {
      api.rerender('524bd414', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/allocation/Step2.vue"
export default component.exports